<nz-layout class="app-layout" [dir]="isRtl ? 'rtl' : 'ltr'" [class.ramadan-layout]="hideFooter">
  <!-- Modern Header -->
  <nz-header *ngIf="!hideChrome" class="modern-header" [class.compact-mode]="isNavbarCompact">
    <!-- Normal Header Container -->
    <div class="header-container" [class.hidden]="isNavbarCompact">
      <!-- Logo Section with Settings Icon -->
      <div class="logo-section">
        <div class="logo-wrapper" [routerLink]="['/', currentLang]">
          <img
            height="40"
            src="../assets/images/logo.svg?v=20260216"
            alt="Quran Apps Directory"
            class="logo-image"
          />
        </div>
      </div>

      <!-- Desktop Navigation - Centered -->
      <nav class="nav-menu">
        <a
          nz-button
          nzType="text"
          [routerLink]="['/', currentLang]"
          class="nav-link"
        >
          {{ "header.home" | translate }}
        </a>
        <a
          nz-button
          nzType="text"
          [routerLink]="['/', currentLang, 'about-us']"
          class="nav-link"
        >
          {{ "header.about" | translate }}
        </a>
        <a
          nz-button
          nzType="text"
          [routerLink]="['/', currentLang, 'contact-us']"
          class="nav-link"
        >
          {{ "header.contact" | translate }}
        </a>
        <a
          nz-button
          nzType="text"
          [routerLink]="['/', currentLang, 'submit-app']"
          class="nav-link"
        >
          {{ "header.submitApp" | translate }}
        </a>
      </nav>

      <!-- Action Buttons - Right Side -->
      <div class="header-actions">
        <a
          nz-button
          nzType="default"
          href="https://community.itqan.dev/"
          target="_blank"
          rel="noopener noreferrer"
          class="community-btn"
        >
          {{ "header.itqan_community" | translate }}
          <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
            <path d="M14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z" />
            <path
              d="M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7z"
            />
          </svg>
        </a>
        <button
          nz-button
          nzType="text"
          nzSize="large"
          (click)="toggleLanguage()"
          class="language-toggle"
        >
          {{ isRtl ? "EN" : "ع" }}
        </button>
        <!-- <app-theme-toggle></app-theme-toggle> -->
      </div>

      <!-- Mobile Menu Button -->
      <button
        nz-button
        nzType="text"
        class="mobile-menu-toggle"
        (click)="toggleMobileMenu()"
        [class.active]="isMobileMenuVisible"
        aria-label="Toggle mobile menu"
      >
        <span class="hamburger-line"></span>
        <span class="hamburger-line"></span>
        <span class="hamburger-line"></span>
      </button>
    </div>

    <!-- Compact Header with Inline Search (Desktop Only) -->
    <div class="header-container-compact" [class.visible]="isNavbarCompact">
      <!-- Logo -->

      <!-- Inline Search Input -->
      <div style="display: flex; align-items: center; gap: 10px">
        <div class="compact-logo" [routerLink]="['/', currentLang]" [class.searching]="isNavbarSearching">
          <img
            src="assets/images/searchLogo.svg"
            alt="Quran Apps"
            width="24"
            height="24"
          />
        </div>
        <div class="compact-search-container">
          <span class="compact-search-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <circle cx="11" cy="11" r="8"></circle>
              <path d="m21 21-4.3-4.3"></path>
            </svg>
          </span>
          <input
            type="text"
            class="compact-search-input"
            [placeholder]="
              currentLang === 'ar' ? 'ابحث عن التطبيقات...' : 'Search apps...'
            "
            [(ngModel)]="navbarSearchQuery"
            (ngModelChange)="onNavbarSearchInput()"
            (keyup.enter)="onNavbarSearch()"
          />
        </div>
      </div>

      <!-- First 5 Category Chips (inline) -->
      @for (category of navbarCategories | slice:0:5; track category.id) {
        <button class="compact-category-chip"
          [class.active]="navbarSelectedCategory === category.slug"
          (click)="onNavbarCategoryClick(category.slug)">
          <span class="compact-chip-icon" [innerHTML]="category.icon || '' | safeHtml"></span>
          <span class="compact-chip-text">
            {{ currentLang === 'ar' ? category.name_ar : category.name_en }}
          </span>
        </button>
      }

      <!-- "More" Dropdown for remaining categories -->
      @if (navbarCategories.length > 5) {
        <div class="compact-category-dropdown" (click)="$event.stopPropagation()">
          <button class="compact-category-trigger"
            [class.active]="isDropdownCategorySelected()"
            (click)="toggleCategoryDropdown($event)">
            <span class="compact-chip-icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16">
                <path fill="currentColor" d="M3.75 3.75v4.5h4.5v-4.5zm-2.25 0A2.25 2.25 0 0 1 3.75 1.5h4.5a2.25 2.25 0 0 1 2.25 2.25v4.5a2.25 2.25 0 0 1-2.25 2.25h-4.5A2.25 2.25 0 0 1 1.5 8.25zm2.25 12v4.5h4.5v-4.5zm-2.25 0a2.25 2.25 0 0 1 2.25-2.25h4.5a2.25 2.25 0 0 1 2.25 2.25v4.5a2.25 2.25 0 0 1-2.25 2.25h-4.5a2.25 2.25 0 0 1-2.25-2.25zm18.75-12h-4.5v4.5h4.5zm-4.5-2.25h4.5a2.25 2.25 0 0 1 2.25 2.25v4.5a2.25 2.25 0 0 1-2.25 2.25h-4.5a2.25 2.25 0 0 1-2.25-2.25v-4.5a2.25 2.25 0 0 1 2.25-2.25m0 14.25v4.5h4.5v-4.5zm-2.25 0a2.25 2.25 0 0 1 2.25-2.25h4.5a2.25 2.25 0 0 1 2.25 2.25v4.5a2.25 2.25 0 0 1-2.25 2.25h-4.5a2.25 2.25 0 0 1-2.25-2.25z"/>
              </svg>
            </span>
            <span class="compact-chip-text">
              @if (isDropdownCategorySelected()) {
                {{ currentLang === 'ar' ? 'التصنيف' : 'Category' }}: {{ getSelectedCategoryName() }}
              } @else {
                {{ currentLang === 'ar' ? 'المزيد' : 'More' }}
              }
            </span>
            <svg class="compact-chevron" [class.open]="isCategoryDropdownOpen" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="m6 9 6 6 6-6"/>
            </svg>
          </button>
          @if (isCategoryDropdownOpen) {
            <div class="compact-category-panel">
              @for (category of navbarCategories | slice:5; track category.id) {
                <button class="compact-category-option"
                  [class.active]="navbarSelectedCategory === category.slug"
                  (click)="onNavbarCategoryClick(category.slug); isCategoryDropdownOpen = false">
                  <span class="compact-chip-icon" [innerHTML]="category.icon || '' | safeHtml"></span>
                  {{ currentLang === 'ar' ? category.name_ar : category.name_en }}
                </button>
              }
            </div>
          }
        </div>
      }

      <!-- Search Button -->
      <button class="compact-search-btn" (click)="onNavbarSearch()">
        {{ "appList.search.button" | translate }}
      </button>
    </div>

    <!-- Modern Mobile Menu -->
    <div class="mobile-menu-overlay" [class.visible]="isMobileMenuVisible">
      <div class="mobile-menu-content">
        <div class="mobile-menu-header">
          <div class="mobile-logo">
            <div class="logo-wrapper" [routerLink]="['/', currentLang]">
              <img
                height="40"
                src="../assets/images/logo.svg?v=20260216"
                alt="Quran Apps Directory"
                class="logo-image"
              />
                </div>
          </div>
          <div style="display: flex; align-items: center; gap: 8px">
            <button
              nz-button
              nzType="text"
              (click)="toggleLanguage(); toggleMobileMenu()"
              class="mobile-language-toggle"
            >
              {{ isRtl ? "EN" : "ع" }}
            </button>
            <button
              nz-button
              nzType="text"
              class="mobile-menu-close"
              (click)="toggleMobileMenu()"
            >
              <lucide-icon name="x" [size]="24"></lucide-icon>
            </button>
          </div>
        </div>

        <nav class="mobile-nav">
          <a
            nz-button
            nzType="text"
            nzBlock
            nzSize="large"
            [routerLink]="['/', currentLang]"
            (click)="toggleMobileMenu()"
            class="mobile-nav-link"
          >
            <span class="mobile-nav-icon">
              <lucide-icon name="home" [size]="20"></lucide-icon>
            </span>
            {{ "header.home" | translate }}
          </a>
          <a
            nz-button
            nzType="text"
            nzBlock
            nzSize="large"
            href="https://community.itqan.dev/"
            target="_blank"
            rel="noopener noreferrer"
            (click)="toggleMobileMenu()"
            class="mobile-nav-link mobile-community-badge"
          >
            <span class="mobile-nav-icon">
              <lucide-icon name="users" [size]="20"></lucide-icon>
            </span>
            {{ "header.itqan_community" | translate }}
            <span class="external-icon">
              <lucide-icon name="external-link" [size]="16"></lucide-icon>
            </span>
          </a>
          <a
            nz-button
            nzType="text"
            nzBlock
            nzSize="large"
            [routerLink]="['/', currentLang, 'about-us']"
            (click)="toggleMobileMenu()"
            class="mobile-nav-link"
          >
            <span class="mobile-nav-icon">
              <lucide-icon name="info" [size]="20"></lucide-icon>
            </span>
            {{ "header.about" | translate }}
          </a>
          <a
            nz-button
            nzType="text"
            nzBlock
            nzSize="large"
            [routerLink]="['/', currentLang, 'contact-us']"
            (click)="toggleMobileMenu()"
            class="mobile-nav-link"
          >
            <span class="mobile-nav-icon">
              <lucide-icon name="mail" [size]="20"></lucide-icon>
            </span>
            {{ "header.contact" | translate }}
          </a>
          <a
            nz-button
            nzType="text"
            nzBlock
            nzSize="large"
            [routerLink]="['/', currentLang, 'submit-app']"
            (click)="toggleMobileMenu()"
            class="mobile-nav-link submit-app-link"
          >
            <span class="mobile-nav-icon">
              <lucide-icon name="plus-circle" [size]="20"></lucide-icon>
            </span>
            {{ "header.submitApp" | translate }}
          </a>
        </nav>

        <div class="mobile-actions">
          <div class="mobile-theme-section">
            <span class="mobile-action-label">&nbsp;</span>
            <!-- <app-theme-toggle></app-theme-toggle> -->
          </div>
        </div>
      </div>
    </div>
  </nz-header>
  <nz-content>
    <router-outlet></router-outlet>
  </nz-content>
  <nz-footer *ngIf="!hideChrome && !hideFooter" class="main-footer">
    <div class="footer-content">
      <!-- Info Row -->
      <div class="footer-info-row">
        <p class="footer-open-source">{{ "footer.copyright" | translate }}</p>
        <div class="footer-sponsor">
          <span class="footer-sponsor-label">{{ "footer.sponsored_by" | translate }}</span>
          <img src="assets/images/charity.svg" alt="" />
          <img class="footer-sponsor-maknon" src="assets/images/maknon.png" alt="" />
        </div>
      </div>
      <!-- Links Row -->
      <div class="footer-links-row">
        <h4 class="footer-links-title">{{ "footer.itqan_projects" | translate }}</h4>
        <ul class="footer-links-list">
          <li>
            <a
              [href]="'https://itqan.dev/' + currentLang"
              target="_blank"
              rel="noopener noreferrer"
            >
              {{ "footer.main_site" | translate }}
            </a>
            <img src="assets/images/link-square.svg" alt="" />
          </li>
          <li>
            <a
              href="https://itqan.dev/projects"
              target="_blank"
              rel="noopener noreferrer"
            >
              {{ "footer.content_management" | translate }}
            </a>
            <img src="assets/images/link-square.svg" alt="" />
          </li>
          <li>
            <a
              href="https://itqan.dev/resources"
              target="_blank"
              rel="noopener noreferrer"
            >
              {{ "footer.resources" | translate }}
            </a>
            <img src="assets/images/link-square.svg" alt="" />
          </li>
        </ul>
      </div>
    </div>
  </nz-footer>
  <app-support></app-support>
</nz-layout>
